import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { ProyectosInvestigacionDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class ProyectosInvestigacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getProyectosInvestigacionService(): Observable<BodyListResponse<ProyectosInvestigacionDTO>> {
    return this.http.get<BodyListResponse<ProyectosInvestigacionDTO>>(API_URL + '/api/v1/proyectosInvestigacion/todos');
  }

  guardarProyectosInvestigacionService(proyectosInvestigacionDTO: ProyectosInvestigacionDTO): Observable<ProyectosInvestigacionDTO> {
    return this.http.post<ProyectosInvestigacionDTO>(API_URL + '/api/v1/proyectosInvestigacion', proyectosInvestigacionDTO);
  }

  getProyectosInvestigacionPorCodigoProyectosInvestigacionService(codigoProyectosInvestigacion: string): Observable<BodyResponse<ProyectosInvestigacionDTO>> {
    return this.http.get<BodyResponse<ProyectosInvestigacionDTO>>(API_URL + '/api/v1/proyectosInvestigacion/' + codigoProyectosInvestigacion);
  }

}
